<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Disciplinas</span>

  <div class="absolute right-0 content-center">
    <ul class="flex-row flex content-center gap-2">
      <li>
        <button mat-icon-button (click)="openDialogCreate()">
          <mat-icon>add</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">

  <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
    <mat-form-field appearance="outline" class="w-full md:w-auto">
      <mat-label>Nombre de la disciplina</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        *ngIf="searchString"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <!--       <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container> -->

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element">
          <label *ngIf="element.estado"> Activa </label>
          <label *ngIf="!element.estado"> inactiva </label>
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            color="accent"
            mat-icon-button
            aria-label="Edit"
            (click)="edit(element)"
          >
            <mat-icon>edit</mat-icon>
          </button>

          <button
            mat-icon-button
            color="warn"
            aria-label="Delete"
            mat-icon-button
            aria-label="Delete"
            (click)="delete(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
